export const SMALL_ACCOUNT_THRESHOLD = 50000;
